var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileNoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9225 9.94499L11.0175 9.72749C10.7935 9.70119 10.5665 9.72598 10.3534 9.80003C10.1404 9.87407 9.94693 9.99543 9.78753 10.155L8.40753 11.535C6.27842 10.4522 4.54787 8.7216 3.46503 6.59249L4.85253 5.20499C5.17503 4.88249 5.33253 4.43249 5.28003 3.97499L5.06253 2.08499C5.02001 1.71913 4.84443 1.38167 4.56921 1.13688C4.29399 0.892087 3.93836 0.757055 3.57003 0.757493H2.27253C1.42503 0.757493 0.72003 1.46249 0.77253 2.30999C1.17003 8.71499 6.29253 13.83 12.69 14.2275C13.5375 14.28 14.2425 13.575 14.2425 12.7275V11.43C14.25 10.6725 13.68 10.035 12.9225 9.94499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNoBlack);
export default __webpack_public_path__ + "static/media/mobileNo-black.10e82edd0c7499cab94d89ebd872273c.svg";
export { ForwardRef as ReactComponent };